import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    get: {
        method: 'GET',
        url: `${BASE_PATH_API}/newaccountsetup`
    },
    initiateAccountSetup: {
        method: 'POST',
        url: `${BASE_PATH_API}/newaccountsetup`
    },
    setSetupCompleteDate: {
        method: 'POST',
        url: `${BASE_PATH_API}/newaccountsetup/setupCompleteDate`
    },
    migrate: {
        method: 'POST',
        url: `${BASE_PATH_API}/newaccountsetup/MigrateFrom30Ds`,
        isArray: true
    },
    //Start Date
    updateStartingDate: {
        method: 'POST',
        url: `${BASE_PATH_API}/newaccountsetup/accountingstartdate`
    },
    //Bank accounts
    getBankAccounts: {
        method: 'GET',
        url: `${BASE_PATH_API}/newaccountsetup/bankaccount`,
        isArray: true
    },
    createBankAccount: {
        method: 'POST',
        url: `${BASE_PATH_API}/newaccountsetup/bankaccount`
    },
    createBankAccounts: {
        method: 'POST',
        url: `${BASE_PATH_API}/newaccountsetup/multipleBankAccounts`,
        isArray: true
    },
    updateBankAccount: {
        method: 'PUT',
        url: `${BASE_PATH_API}/newaccountsetup/bankaccount/:id`
    },
    removeBankAccount: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/newaccountsetup/bankaccount/:id`
    },
    //Late fee policies
    getLateFeePolicies: {
        method: 'GET',
        url: `${BASE_PATH_API}/newaccountsetup/policies/lateFee`
    },
    createLateFeePolicies: {
        method: 'PUT',
        url: `${BASE_PATH_API}/newaccountsetup/policies/lateFee`
    },
    updateLateFeePolicies: {
        method: 'PUT',
        url: `${BASE_PATH_API}/newaccountsetup/policies/lateFee`
    },
    removeLateFeePolicies: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/newaccountsetup/policies/lateFee`
    },
    //Management fee policies
    getManagementFeePolicies: {
        method: 'GET',
        url: `${BASE_PATH_API}/newaccountsetup/policies/managementFee`
    },
    createManagementFeePolicies: {
        method: 'PUT',
        url: `${BASE_PATH_API}/newaccountsetup/policies/managementFee`
    },
    updateManagementFeePolicies: {
        method: 'PUT',
        url: `${BASE_PATH_API}/newaccountsetup/policies/managementFee`
    },
    removeManagementFeePolicies: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/newaccountsetup/policies/managementFee`
    },
    //other policies
    getOtherPolicies: {
        method: 'GET',
        url: `${BASE_PATH_API}/newaccountsetup/policies`
    },
    createOtherPolicies: {
        method: 'PUT',
        url: `${BASE_PATH_API}/newaccountsetup/policies`
    },
    updateOtherPolicies: {
        method: 'PUT',
        url: `${BASE_PATH_API}/newaccountsetup/policies`
    },
    removeOtherPolicies: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/newaccountsetup/policies`
    },
    //Property Setup
    getPropertyStatus: {
        method: 'GET',
        url: `${BASE_PATH_API}/newaccountsetup/propertyStatus`
    },
    checkSetupStatus: {
        method: 'GET',
        url: `${BASE_PATH_API}/newaccountsetup/propertySetup/isInEntryState`
    },
    setSetupStatus: {
        method: 'POST',
        url: `${BASE_PATH_API}/newaccountsetup/propertySetup/complete`
    },
    deleteProperty: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/newaccountsetup/property/:Id`
    },
    deleteUnit: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/newaccountsetup/unit/:id`
    }
};

export function NewAccountSetupApi() {
    return createActions(actions);
}
